import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { LabelL } from '@sorare/core/src/atoms/typography';
import { Box } from '@sorare/core/src/atoms/ui/Box';

const Root = styled.div`
  padding: 0 var(--double-unit);
`;
const StyledBox = styled(Box)`
  background: var(--c-neutral-300);

  &.backdropFilter {
    background: rgba(var(--c-rgb-neutral-100), 0.15);
    backdrop-filter: blur(32px);
  }
`;

type Props = { children: ReactNode; backdropFilter?: boolean };
export const Description = ({ children, backdropFilter = true }: Props) => {
  return (
    <Root>
      <StyledBox className={classNames({ backdropFilter })}>
        <LabelL className="text-center">{children}</LabelL>
      </StyledBox>
    </Root>
  );
};
